export class AudioManager {
    constructor() {
        this.audioContext = null;
        this.enabled = true;
        this.volume = 0.3;
        
        this.init();
    }
    
    init() {
        try {
            this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
        } catch (error) {
            console.warn('Web Audio API not supported:', error);
            this.enabled = false;
        }
    }
    
    createTone(frequency, duration, type = 'sine', volume = 0.1) {
        if (!this.enabled || !this.audioContext) return;
        
        const oscillator = this.audioContext.createOscillator();
        const gainNode = this.audioContext.createGain();
        
        oscillator.connect(gainNode);
        gainNode.connect(this.audioContext.destination);
        
        oscillator.frequency.setValueAtTime(frequency, this.audioContext.currentTime);
        oscillator.type = type;
        
        gainNode.gain.setValueAtTime(0, this.audioContext.currentTime);
        gainNode.gain.linearRampToValueAtTime(volume * this.volume, this.audioContext.currentTime + 0.01);
        gainNode.gain.exponentialRampToValueAtTime(0.001, this.audioContext.currentTime + duration);
        
        oscillator.start(this.audioContext.currentTime);
        oscillator.stop(this.audioContext.currentTime + duration);
    }
    
    playShoot() {
        this.createTone(800, 0.1, 'square', 0.05);
    }
    
    playHit() {
        this.createTone(400, 0.1, 'sawtooth', 0.08);
    }
    
    playExplosion() {
        // Create explosion noise
        if (!this.enabled || !this.audioContext) return;
        
        const noiseBuffer = this.audioContext.createBuffer(1, this.audioContext.sampleRate * 0.3, this.audioContext.sampleRate);
        const output = noiseBuffer.getChannelData(0);
        
        for (let i = 0; i < output.length; i++) {
            output[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / output.length, 2);
        }
        
        const noiseSource = this.audioContext.createBufferSource();
        const gainNode = this.audioContext.createGain();
        
        noiseSource.buffer = noiseBuffer;
        noiseSource.connect(gainNode);
        gainNode.connect(this.audioContext.destination);
        
        gainNode.gain.setValueAtTime(0.1 * this.volume, this.audioContext.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(0.001, this.audioContext.currentTime + 0.3);
        
        noiseSource.start();
    }
    
    playLevelUp() {
        // Ascending scale
        const frequencies = [440, 523, 659, 880];
        frequencies.forEach((freq, index) => {
            setTimeout(() => {
                this.createTone(freq, 0.2, 'sine', 0.1);
            }, index * 100);
        });
    }
    
    playPickup() {
        this.createTone(880, 0.15, 'sine', 0.06);
        setTimeout(() => {
            this.createTone(1320, 0.1, 'sine', 0.04);
        }, 50);
    }
    
    playBossSpawn() {
        // Ominous low tone
        this.createTone(80, 1.0, 'sawtooth', 0.15);
        setTimeout(() => {
            this.createTone(120, 0.8, 'square', 0.1);
        }, 200);
    }
} 